import { ref } from 'vue'
import useAppStore from '@views/app.store'
import { getKnowledgeList } from '@views/home/knowledge/api/index'
import { useCrossTabListen } from '@utils/useCrossTabBus'

/**
 * @description: 获取知识库列表
 * @return {*}
 */
export function getKnowledgeListByMode(geoMode?: 'inner' | 'outer') {
  const knowledgeList = ref([])
  const mode = geoMode || useAppStore().geoMode
  const isInner = mode === 'inner'
  const fetchList = () => {
    getKnowledgeList({ pageNum: 1, pageSize: 9999 }).then(res => {
      if (res.data?.list) {
        knowledgeList.value = res.data.list.filter(item => {
          if (isInner) {
            return item.inCompanyKnowledge && item.inCompanyKnowledge.workflowStatus === 3
          }
          return item.outCompanyKnowledgeInfos && item.outCompanyKnowledgeInfos.workflowStatus === 3
        })
      }
    })
  }
  // 自动触发调用
  fetchList()

  // 增加广播监听
  useCrossTabListen('KNOWLEDGE_REFRESH', fetchList)
  return {
    knowledgeList,
  }
}
